import script from "./CreateDelegationPage.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateDelegationPage.vue?vue&type=script&setup=true&lang=js"

import "./CreateDelegationPage.vue?vue&type=style&index=0&id=40d5bc3d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-40d5bc3d"]])

export default __exports__